module.exports = "/_next/static/images/5-1-511b8b43b70a9fadb3240ba7d4a2925f.svg";